import AxiosAdminAPI from "../../../../util/AxiosAdminAPI";
import AxiosFoundationAPI from "../../../../util/AxiosFoundationAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1UserGroupIDOCToArray} from "../../../../util/Payload";
import {v4 as uuidv4} from "uuid";

class UserGroupEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.UserGroup-001";

        let QBE = {
            "PlatformMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                "UserGroup": {
                    '_attributes': {
                        'limit': pageSize,
                        'sort': this.getFormattedSortSpecification(),
                        'offset': (page - 1) * pageSize
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "primary",
                                "Operator": "AND",
                                "Type": "QueryGroup",
                                "Membership": {
                                    "Member": []
                                }
                            }
                        ]
                    }
                }
            }
        }
        let queryPayload = this.prepareQueryPayload();

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;

                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) {
                    operator = queryPayload.get(key + "_query")
                }
                QBE.PlatformMessage.UserGroup.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": value,
                    "Operator": operator
                })
            }
        }

        // AND THE FOUNDATION CLIENT, because that is the host the t1 path lives on. Moving the
        // URL from t6 to t1 while leaving AxiosAdminAPI here sent every read to
        // REACT_APP_ADMIN_API_URL + "/t1/v1/user_groups" -- a route that does not exist on the
        // admin API, so API Gateway answered 403 Forbidden AT THE EDGE. It never reached a lambda,
        // which is why nothing was written to DEVELOPER_EXCEPTION and the System Error dialog was
        // the only evidence that anything had happened. PositionEnterpriseComponent had this right
        // from the start: Foundation client for the t1 read, admin client for the t6 writes.
        AxiosFoundationAPI({
            method: "GET",
            // READ FROM t1, WRITE TO t6, exactly as PositionEnterpriseComponent does and for the
            // same reason. Every read in t6's Administration application requires `administrator`,
            // and this component backs the GROUP PICKERS -- the Stewardship tab's, and the Training
            // Setup screen's. A non-administrator got a 403, the EC turned it into the System Error
            // dialog, and the screen read as broken. Ed: "The training setup screen throws a system
            // error"; the exception records named it, CC-PRIV-DENY on GET /t6/v1/user_groups.
            //
            // Positions were moved for this reason and these two were left behind. Creating,
            // renaming and changing the membership of a group is administration and is unchanged:
            // the calls below still go to t6, where they are gated and where they belong.
            url: "t1/v1/user_groups",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1UserGroupIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let adminUserGroup = {};

        adminUserGroup["USID"] = this.getAttributeValue("USID");
        adminUserGroup["Name"] = this.getAttributeValue("Name");
        adminUserGroup["Status"] = 'Active';
        adminUserGroup["PrimaryAccountUserUSID"] = this.getAttributeValue("PrimaryAccountUserUSID");

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.UserGroup-001";
        payload.PlatformMessage.UserGroup = adminUserGroup;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t6/v1/user_groups",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.UserGroup-001",
                "idoc-response": "v1.UserGroup-001"
            },
        };
        this.notifyInsertStartListeners();
        AxiosAdminAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1UserGroupIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.UserGroup-001";
        payload.PlatformMessage.UserGroup = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t6/v1/user_groups",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.UserGroup-001",
                "idoc-response": "v1.UserGroup-001",
            },
        };
        this.notifyUpdateStartListeners();
        AxiosAdminAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1UserGroupIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

}

export default UserGroupEnterpriseComponent;